module.exports = __webpack_public_path__ + "assets/29ec61163846b02f67794286e3491017.png";